export default {
  budgetedLabor: {
    value: 0,
    maxlength: '10',
    required: true,
    state: null,
    defaultValue: 0
  },
  approvedLabor: {
    value: 0,
    maxlength: '10',
    required: true,
    state: null,
    defaultValue: 0
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/typing/modal/modalsinistertyping-form.js